var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bgModal"},[_c('section',{staticClass:"modal"},[_c('span',{staticClass:"textLoader"},[_vm._v(_vm._s(_vm.$t('language.posadasCorporate.login.loader')))]),_c('span',{staticClass:"loader"})])])}
var staticRenderFns = []

export { render, staticRenderFns }